.quill-editor {
  width: 100%;
  position: relative;
  border: 1px solid #cccccc;
  height: 100%;
  background-color: white;
  border-radius: 4px;

  .ql-container {
    border: none;
    padding-bottom: 45px;
  }

  .ql-toolbar {
    position: absolute !important;
    bottom: 40px;
    width: 100%;
    transform: translateY(100%);
    z-index: 1;
    border: none;
  }

  &.toolbar-hidden {
    .ql-toolbar {
      display: none;
    }

    .ql-container {
      padding-bottom: 5px;
    }
  }

  .ql-tooltip {
    z-index: 1;
  }

  .ql-stroke {
    stroke: #777070;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #a8a8a8;
  }
}

.toolbar-container::-webkit-scrollbar {
  height: 4px;
  /* Control the thickness of the scrollbar */
}

.toolbar-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* Color of the track */
}

.toolbar-container::-webkit-scrollbar-thumb {
  background: #888;
  /* Color of the scrollbar itself */
}

.toolbar-container::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* Color when hovered */
}
